export const scheduleToPathNameMap = (function () {
    const scheduleBase = '/schedule';
    return {
        schedule1010: ({ businessKey, code } = {
            businessKey: '',
            code: '',
        }) => {
            return `${scheduleBase}/plan/add/Detail?id=${businessKey}`;
        },
        schedule1020: ({ businessKey, code } = {
            businessKey: '',
            code: '',
        }) => {
            return `${scheduleBase}/plan/edit/Detail?id=${businessKey}`;
        },
        schedule1030: ({ businessKey, code } = {
            businessKey: '',
            code: '',
        }) => {
            return `${scheduleBase}/plan/submit/Detail?id=${businessKey}`;
        },
        schedule1040: ({ businessKey, code } = {
            businessKey: '',
            code: '',
        }) => {
            return `${scheduleBase}/rule/log?id=${businessKey}`;
        },
        schedule1060: ({ businessKey, code } = {
            businessKey: '',
            code: '',
        }) => {
            return `${scheduleBase}/progress/images/Detail?id=${businessKey}`;
        }
    };
})();
